import React from 'react'

import { IoIosArrowForward as ArrowForwardIosSharpIcon } from "react-icons/io"
import { BiPlanet } from "react-icons/bi"
import { BsBrush } from "react-icons/bs"
import { IoCashOutline, IoWalletOutline, IoHandRightOutline, IoColorPaletteOutline } from "react-icons/io5"


import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { Parallax } from "react-parallax";

import Astroid9 from "../../../../assets/images/astroid9.png"
import Astroid5 from "../../../../assets/images/astroid5.png"
import Ship3 from "../../../../assets/images/ship3.gif"

import "./Utilities.scss"



const AcorData = [
    {
        img: <BiPlanet />,
        p1: "Future Plans",
        p2: 'Expansion of the Metaverse',
        detail: 'The Metaverse Marauders universe, will expand, and MM holders will benefit from new collections and at least a Play 2 Earn.'
    },
    {
        img: <BsBrush />,
        p1: "DagaLabs",
        p2: 'NFT Studio',
        detail: <> <p> In DagaLabs (our NFT studio), we will work with celebrities and brands, we are already discussing with several celebrities; to create their NFT collection (art and utility) and host them exclusively on our Sandaga NFT MarketPlace. </p> <br /> <p> These exclusive sales on Sandaga should attract a lot of people, willing to get a piece of these collections from their favorite celebrities : for every collection a defined amount of Metaverse Marauders holders will have access to either an airdrop or a whitelist. </p> </>
    },
    {
        img: <IoCashOutline />,
        p1: "Our own token",
        p2: '$DAGA',
        detail: 'Sandaga, our NFT Marketplace and way more, will soon have its own token : the $DAGA. Every Metaverse Marauders will be able to claim $DAGA. Tokenomics and date will be announced soon.'
    },
    {
        img: <IoWalletOutline />,
        p1: "Incomes",
        p2: 'Collection’s royalties',
        detail: "Every Metaverse Marauders will get a % of revenue sharing from the collection's royalties and all derivative (art, merch, film, ...). Your Metaverse Marauders will generate passive income for you."
    },
    {
        img: <IoHandRightOutline />,
        p1: "Governance",
        p2: 'Power to the community',
        detail: 'MM holders will participate in the governance through voting and allocation community funds. They will also be able to vote for the decisions in the Sandaga Education Program (through $DAGA).'
    },
    {
        img: <IoColorPaletteOutline />,
        p1: "Customization",
        p2: 'Enhance your profile',
        detail: <> Your Metaverse Marauders will give you access to a personal and customizable space, to highlight whatever you want in front of the Metaverse Marauders and Sandaga audience. <br />
            This space will be a sub-domain of the Metaverse Marauders, and a dedicated page with every MM holders having 1 space of a Map, composed of 12 000 spaces (more details soon). </>
    },
]

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    fontFamily: "Poppins",
    color: "white",
    border: `none`,
    cursor: 'pointer',
    "&::hover": {
        backgroundColor: "red"
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon color='white' size="1rem" />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


const Utilities = () => {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <>
            <div className="utility_container">
                <div className="box">
                    <div className="data">
                        <Parallax
                            renderLayer={(percentage) => {
                                let t = percentage * 1300
                                return (
                                    <div className="ship3" style={{ transform: `translateX(${-t + 520}%)` }} >
                                        <img src={Ship3} alt="ERROR" />
                                    </div>
                                )
                            }}
                        >
                            <img src={Astroid9} alt="ERROR" className='astroid9' />
                            <img src={Astroid5} alt="ERROR" className='astroid5' />
                            <div className="heading">
                                Utilities
                            </div>
                            <div className="acordian">
                                {
                                    AcorData.map((data, index) => {
                                        return (
                                            <>
                                                <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)}>
                                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                                        <div className="title">
                                                            <div className="img">
                                                                {data.img}
                                                            </div>
                                                            <div className="detail">
                                                                <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}> {data.p1} </p>
                                                                <p> {data.p2} </p>
                                                            </div>
                                                        </div>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Typography>
                                                            {data.detail}
                                                        </Typography>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </>
                                        )
                                    })
                                }

                            </div>
                        </Parallax>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Utilities
